import React from "react";
import styles from "./style";
import lixeira from "../../../images/lixeira.svg";

const getName = (name) => {
    let newName = name.split(".");
    if (newName.length > 2) {
        let completeName = "";
        let limit = newName.length - 1;
        for (let i = 0; i < limit; i++) {
            completeName += newName[i];
        }
        return completeName;
    }
    return newName[0];
};

const getType = (type) => {
    let newType = type.split("/");
    try {
        return newType[1];
    } catch (error) {
        return "";
    }
};

const getSize = (tamanho) => {
    if (tamanho >= (1024 * 1024 * 1024)) {
        return `${parseInt(tamanho / (1024 * 1024 * 1024))}gb`;
    }
    if (tamanho >= (1024 * 1024)) {
        return `${parseInt(tamanho / (1024 * 1024))}mb`;
    }
    if (tamanho >= 1024) {
        return `${parseInt(tamanho / 1024)}kb`;
    }
    return `${tamanho}bytes`;
}

const ListaArquivos = (props) => {
    const { arquivos = [], onRemove } = props;
    const css = styles();
    if (arquivos.length === 0) {
        return (<React.Fragment />);
    }
    return (
        <div>
            <div className={css.header}>
                <span className={css.headerSpan}>Arquivo</span>
                <span className={css.headerSpanLast}>Formato e Tamanho</span>
            </div>
            {arquivos.map((item, key) => (
                <div style={{backgroundColor:key%2===0 ? '#F5F7FA':'#fff'}} key={key} className={css.arquivo}>
                    <div style={{ display: 'flex', alignItems: 'center', width:'80%' }}>
                        <img style={{ cursor: 'pointer', marginRight: '10.25px' }} onClick={() => onRemove(key, item.id)} src={lixeira} alt='icone de lixeira'/>
                        <span className={css.footerSpan}>{getName(item.name)}</span>
                    </div>
                    <span className={css.footerSpanLast}>{getType(item.type).toUpperCase()} | {getSize(item.size).toUpperCase()}</span>
                </div>
            ))}
            <div className={css.footer}>
                <span className={css.footerSpan}>{arquivos.length} arquivos</span>
            </div>
        </div>
    );
}

export default ListaArquivos;
